module.exports = __webpack_public_path__ + "static/media/pendente.f92e68db.svg";